export * from './BedIcon';
export * from './CarIcon';
export * from './PhoneIcon';
export * from './PlaneIcon';
export * from './SuitcaseIcon';
export * from './WhatsAppIcon';
export * from './FacebookIcon';
export * from './TwitterIcon';
export * from './PinterestIcon';
export * from './InstagramIcon';
export * from './YouTubeIcon';
